import { render, staticRenderFns } from "./VlMeasuresItem.vue?vue&type=template&id=34e47e5e&"
import script from "./VlMeasuresItem.vue?vue&type=script&lang=js&"
export * from "./VlMeasuresItem.vue?vue&type=script&lang=js&"
import style0 from "./VlMeasuresItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports